import { z } from "zod";

const notesSchema = z.object({
	notes: z.string().trim().min(3, "errors.description_name_must_least_3_characters"),
});

export type NotesFormData = z.infer<typeof notesSchema>;

export { notesSchema };
